import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Tab} from 'semantic-ui-react';

import {Line} from '../../../util/plotHelpers/types';
import * as Types from '../../../util/queryTypes';
import PanelChartOptions from '../../PanelChartOptions';
import {usePanelConfigContext} from '../PanelConfigContext';
import {RunsLinePlotConfig} from '../types';
import {useLegendVisibility} from '../useLegendVisibility';

type EditChartTabProps = {
  config: RunsLinePlotConfig;
  updateConfig: (config: Partial<RunsLinePlotConfig>) => void;
  pageQuery: Types.Query;
  lines: Line[];
};

export const EditChartTab = (props: EditChartTabProps) => {
  const {isSingleRun, showLegend} = usePanelConfigContext();
  const isLegendShown = useLegendVisibility(isSingleRun, showLegend);

  return (
    <Tab.Pane as="div" className="form-grid">
      <PanelChartOptions
        config={props.config}
        pageQuery={props.pageQuery}
        showLegend={isLegendShown}
        type={'lines'}
        updateConfig={props.updateConfig}
      />
    </Tab.Pane>
  );
};
